let sliders = {}; // To store slider instances by their ID
let currentViewport = window.innerWidth;

function initializeSlider(el) {
    const sliderId = el.dataset.sliderId;
    const autoplay = el.dataset.autoplay;
    const slider = tns({
        container: `[data-listing-carousel-block-slider="${sliderId}"]`,
        controls: true,
        controlsContainer: `[data-listing-carousel-block-controls="${sliderId}"]`,
        fixedWidth: 300,
        autoplay: autoplay === "True",
        autoplayTimeout: 5000,
        loop: true,
        center: true,
        gutter: 20,
        nav: false,
        responsive: ({
            "768": {
                "fixedWidth": 280
            },
            "992": {
                "fixedWidth": 340
            }
        }),
    });
    
    el.querySelectorAll(`[data-listing-carousel-block-controls="${sliderId}"]`).forEach(c => {
        c.removeAttribute('aria-label');
    });
    
    sliders[sliderId] = slider;
}

function destroySlider(sliderId) {
    if (sliders[sliderId]) {
        sliders[sliderId].destroy();
        delete sliders[sliderId];
    }
}

document.querySelectorAll('.listing-carousel-block').forEach(el => {
    if (!el.classList.contains('listing-carousel-block--not-slider')) {
        initializeSlider(el);
    }
});

window.addEventListener('resize', () => {
    const newViewport = window.innerWidth;
    if ((currentViewport < 768 && newViewport >= 768) ||
        (currentViewport >= 768 && currentViewport < 992 && (newViewport < 768 || newViewport >= 992)) ||
        (currentViewport >= 992 && newViewport < 992)) {
        document.querySelectorAll('.listing-carousel-block').forEach(el => {
            if (!el.classList.contains('listing-carousel-block--not-slider')) {
                const sliderId = el.dataset.sliderId;
                destroySlider(sliderId);
                initializeSlider(el);
            }
        });
    }

    currentViewport = newViewport;
});
